import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import LiveDropletDashboard from './components/LiveDropletDashboard';
import BandwidthDashboard from './components/BandwidthDashboard';
import ServerlessInferenceDashboard from './components/ServerlessInferenceDashboard';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/droplets"
          element={
            <PrivateRoute>
              <Layout>
                <LiveDropletDashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/bandwidth"
          element={
            <PrivateRoute>
              <Layout>
                <BandwidthDashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/serverless-inference"
          element={
            <PrivateRoute>
              <Layout>
                <ServerlessInferenceDashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default App;